// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"eccc0298","112":"405b7336","168":"8cd357c9","592":"fa6d22d8","616":"78b25119","688":"c3ee0d42","832":"3e5d635a"}[chunkId] + ".chunk.js";
};